export const batch = <T>(target: T[], batchSize: number, offset: number = 0): T[][] => {
  return target.reduce((res, item, index) => {
    const chunkIndex = Math.floor((index + offset) / batchSize);
    if (!res[chunkIndex]) {
      res[chunkIndex] = [];
    }
    res[chunkIndex].push(item);
    return res;
  }, [])
};

export const range = <T>(bound: number, producer: (number) => T = i => i) => {
  const arr = [];

  for (let i = 0; i < bound; i++) {
    arr.push(producer(i));
  }

  return arr;
};
